import { Controller } from "@hotwired/stimulus"

// Keeps the "Run GridSignal Scan" button in Market Finder in sync
// with the row checkboxes. Enables/disables the submit button
// based on checked state and writes a comma-separated list of
// geography IDs (via the browser's standard array-param form
// handling) into the hidden input right before submit.
//
// Attaches to:
//   <form data-controller="mf-gridsignal" ...>
//     <input type="hidden" name="geography_ids" data-mf-gridsignal-target="ids">
//     <button data-mf-gridsignal-target="submit" disabled>Run GridSignal Scan</button>
//   </form>
export default class extends Controller {
  static targets = ["ids", "submit"]

  connect() {
    this.boundSync = this.sync.bind(this)
    document.addEventListener("change", this.boundSync)
    this.sync()
    // Rebuild the hidden input as a real array of inputs right
    // before the browser serializes the form.
    this.element.addEventListener("submit", (e) => this.beforeSubmit(e))
  }

  disconnect() {
    document.removeEventListener("change", this.boundSync)
  }

  sync() {
    const checked = this.checkedIds()
    this.submitTarget.disabled = checked.length === 0
    this.submitTarget.textContent = checked.length > 0
      ? `Run GridSignal Scan (${checked.length})`
      : "Run GridSignal Scan"
  }

  checkedIds() {
    return Array.from(document.querySelectorAll('[data-market-finder-target="checkbox"]:checked'))
      .map(cb => cb.value)
      .filter(Boolean)
  }

  beforeSubmit(event) {
    const checked = this.checkedIds()
    if (checked.length === 0) {
      event.preventDefault()
      return
    }
    // Remove the single hidden input and append one per id, so
    // Rails parses them as an array under params[:geography_ids].
    this.idsTarget.remove()
    checked.forEach(id => {
      const inp = document.createElement("input")
      inp.type  = "hidden"
      inp.name  = "geography_ids[]"
      inp.value = id
      this.element.appendChild(inp)
    })
  }
}
